export default __webpack_public_path__ + "static/media/shield-icon.be334f6d.svg";